import getProp from '@f/get-prop'

export const getSourceSettingsValidationRequest = (state) =>
  getProp('sourceSettingsValidation', state)

export const getSourceSettingsValidationErrors = (state, levels) => {
  const errors = getSourceSettingsValidationRequest(state).data

  if (levels) {
    return errors.filter((error) => levels.includes(error.level))
  }

  return errors
}



// WEBPACK FOOTER //
// ./selectors/source-settings-validation.js